const ENDPOINT = 'uri/operations/zip';
const handleZip = (props) => {
    const { files, session, additional: { swIntercept, gw, host, addURIParam, uriKey, zipName }, } = props;
    const { lcid, accessToken } = session;
    const iframe = document.createElement('iframe');
    iframe.setAttribute('data-type', 'download-iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;
    const form = iframeDocument.createElement('form');
    form.rel = 'noopener noreferrer';
    form.id = 'download-zip';
    form.method = 'POST';
    form.action = `${host}/user/${lcid}/${ENDPOINT}`;
    files?.length &&
        files.forEach(({ uri }) => {
            const hiddenField = iframeDocument.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.name = 'uri';
            hiddenField.value = uri;
            form.appendChild(hiddenField);
        });
    if (zipName) {
        const hiddenField2 = iframeDocument.createElement('input');
        hiddenField2.type = 'hidden';
        hiddenField2.name = 'name';
        hiddenField2.value = zipName;
        form.appendChild(hiddenField2);
    }
    if (swIntercept) {
        const NWBfield = iframeDocument.createElement('input');
        NWBfield.type = 'hidden';
        NWBfield.name = 'NWB';
        NWBfield.value = `${accessToken}`;
        form.appendChild(NWBfield);
    }
    if (addURIParam) {
        const urlParams = new URLSearchParams([[uriKey, session?.host?.toString()]]);
        form.action = `${form.action}?${urlParams.toString()}`;
    }
    iframeDocument.body.appendChild(form);
    form.addEventListener('submit', (event) => {
        event.preventDefault();
        document.body.removeChild(iframe);
    });
    form.submit();
};
export const downloadZip = (props) => handleZip(props);
